import type { ZodError } from 'zod';

/**
 * Erros de um schema do contrato → mapa plano `caminho → mensagem`.
 *
 * POR QUE NÃO `zodResolver`
 * Os formulários do SGQ coletam campos PLANOS (`severity`, `urgency`, `trend`,
 * `dueDate` como texto) e o schema do contrato valida um objeto ANINHADO e
 * COAGIDO (`gut: {…}`, `dueDate: Date`). O `zodResolver` do React Hook Form
 * valida a estrutura do formulário, não a do comando — e ficaria preso a uma
 * conversão de tipos que só existiria para enganar o compilador.
 *
 * Aqui o caminho é o oposto e é o que o projeto já faz no servidor: monta-se o
 * COMANDO e roda-se o schema do contrato sobre ele. A validação que reprova é
 * exatamente a mesma que o DTO NestJS aplica — não há um segundo conjunto de
 * regras no cliente, que é a origem do BUG-NC-10 no legado (controller e model
 * liam nomes de campo diferentes e a NC era gravada vazia com a validação
 * passando).
 *
 * A chave é `issue.path.join('.')`, então um erro em `gut.severity` fica
 * acessível como `errors['gut.severity']` — que é o que `<GutMatrix>` consome.
 * A PRIMEIRA mensagem de cada caminho é a que fica: exibir três mensagens no
 * mesmo campo é ruído.
 */
export function zodIssuesToFieldErrors(error: ZodError): Readonly<Record<string, string>> {
  const errors: Record<string, string> = {};
  for (const issue of error.issues) {
    const key = issue.path.join('.') || '_form';
    if (errors[key] === undefined) errors[key] = issue.message;
  }
  return errors;
}

/** Mensagens sem campo associado — vão para o bloco de erro do formulário. */
export function formLevelMessage(errors: Readonly<Record<string, string>>): string | null {
  return errors._form ?? null;
}
